export const PERIODS = ['YTD', '1Y', 'QUARTER'] as const;
